import {Typography} from '@mui/material';
import {useAppTranslation} from '@mybake/ui/hooks/useAppTranslation';
import {useCurrency} from '../../hooks/useCurrency';

export const PurchaseEstimatedCost = ({value}: {value: number}) => {
    const {t} = useAppTranslation();
    const {formatCurrency} = useCurrency();
    return <Typography fontWeight={600}>{t('home:estimated_purchase_cost')}: {formatCurrency(value)}</Typography>;
};
